import { statusItems } from '@/mocks/home';

export default function Hero() {
  return (
    <section id="top" className="relative w-full overflow-hidden">
      <div className="absolute inset-0 h-full w-full">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20dramatic%20amber%20and%20crimson%20gradient%20waves%20on%20deep%20charcoal%20background%2C%20editorial%20lighting%2C%20high%20contrast%2C%20cinematic%2C%20no%20text%2C%20dark%20tones%20for%20overlay&width=1920&height=1080&seq=baoliao-hero-01&orientation=landscape"
          alt=""
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/60 to-black/70" />
      </div>

      <div className="relative mx-auto flex w-full max-w-[1280px] flex-col items-center px-4 py-16 text-center md:px-6 md:py-24">
        <span className="mb-5 inline-flex items-center gap-2 rounded-full border border-background-50/25 bg-background-50/10 px-4 py-1.5 text-xs text-background-100 backdrop-blur">
          <i className="ri-shield-star-line text-primary-300" aria-hidden="true" />
          官方入口 · 最新地址 · 客户端下载 一站直达
        </span>

        <h1 className="max-w-4xl font-heading text-3xl font-bold leading-tight text-background-50 md:text-5xl">
          爆料网官网入口与最新地址导航
        </h1>

        <p className="mt-5 max-w-2xl text-sm leading-relaxed text-background-200 md:text-base">
          汇总爆料网官网入口、最新可用网址与 App 下载方式，帮你在换地址、找入口时快速定位，
          避免误入仿冒站点。所有线路每日巡检，入口发生变化时第一时间更新。
        </p>

        <div className="mt-8 flex w-full flex-col items-center justify-center gap-3 sm:flex-row">
          <a
            href="#entry"
            className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 sm:w-auto"
          >
            <i className="ri-link-m text-base" aria-hidden="true" />
            查看入口导航
          </a>
          <a
            href="#app"
            className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/30 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-background-50/10 sm:w-auto"
          >
            <i className="ri-smartphone-line text-base" aria-hidden="true" />
            App 下载方式
          </a>
        </div>

        <div className="mt-12 grid w-full max-w-3xl grid-cols-2 gap-3 md:grid-cols-4">
          {statusItems.map((item) => (
            <div key={item.label} className="rounded-lg border border-background-50/15 bg-background-50/10 px-4 py-3 backdrop-blur">
              <p className="text-xs text-background-200">{item.label}</p>
              <p className="mt-1 font-heading text-base font-semibold text-background-50">{item.value}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}